import React from 'react';
import { MovieTrailerContainer } from './MovieTrailer';

export default class Movies extends React.PureComponent {
  render() {
    return (
      <section className="cp-bib-movies">
        <MovieTrailerContainer />
      </section>
    );
  }
}
